import request from '@/utils/request'

export const getSchedulingList = ({ page, size, keywords: name }) => {
  return request({
    url: `/trace/orderclasses/${page}/${size}`,
    params: {
      name
    }
  })
}

export const putSchedulingAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/orderclasses',
    data
  })
}

export const postSchedulingEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/orderclasses',
    data
  })
}

export const getSchedulingDetail = (id) => {
  return request({
    url: `/trace/orderclasses/${id}`
  })
}

export const deleteSchedulingDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/orderclasses/${id}`
  })
}

export const delSchedulingList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/orderclasses/all',
    data
  })
}
